import { IconButton, Stack } from '@ltvco/refresh-lib/theme';
import {
  CancellationReasonsModal,
  CancelUserExperienceModal,
  ConfirmCancelModal,
  ContactOptionsModal,
  TrustPilotModal,
} from '@ltvco/refresh-lib/v1';
import { Close } from '@mui/icons-material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { constants } from 'appConstants';
import { SalesLeadModal } from 'components/SalesLeadModal';
import { UpgradePlanPage as UpgradePlanPageComponent } from 'routes/Upgrade/UpgradePlanPage';

import { ChatPageContainerStack } from '../ChatPage/ChatComponents/components';

export const UpgradePlanPage = () => {
  const navigate = useNavigate();
  const [isContactOptionsModalOpen, setIsContactOptionsModalOpen] =
    useState(false);
  const [isUpgradeLeadModalOpen, setIsUpgradeLeadModalOpen] = useState(false);
  const [isConfirmCancelModalOpen, setIsConfirmCancelModalOpen] =
    useState(false);
  const [showCheaperPlanLink, setShowCheaperPlanLink] = useState(false);
  const [isCancellationReasonsModalOpen, setIsCancellationReasonsModalOpen] =
    useState(false);
  const [, setIsSuccessModaVisible] = useState<boolean>(false);
  const [, setIsDownsellOfferModalOpen] = useState(false);
  const [isUserExperienceSurveyModalOpen, setIsUserExperienceSurveyModalOpen] =
    useState(false);
  const [isTrustPilotModalOpen, setIsTrustPilotModalOpen] = useState(false);

  const openConfirmCancelModal = (downsellTest?: boolean) => {
    setIsConfirmCancelModalOpen(true);
    setShowCheaperPlanLink(downsellTest || false);
  };

  const openSuccessModal = () => {
    setIsSuccessModaVisible(true);
  };

  const handleContactUs = () => {
    setIsContactOptionsModalOpen(true);
  };

  const handleCloseUpgradePlan = () => {
    navigate('/chatbv/chat');
  };

  const handleCancellationModalClose = (reason: string | undefined) => {
    setIsCancellationReasonsModalOpen(false);
    if (reason === 'Too expensive') {
      setIsDownsellOfferModalOpen(true);
    } else if (reason === 'Other' || reason === 'No longer needed') {
      setIsUserExperienceSurveyModalOpen(true);
    }
  };

  const handleCloseUserExperienceSurveyModal = (
    rating: string | null | undefined
  ) => {
    setIsUserExperienceSurveyModalOpen(false);
    if (rating && parseInt(rating) >= 8) {
      setIsTrustPilotModalOpen(true);
    }
  };

  return (
    <ChatPageContainerStack>
      <Stack width="100%" justifyContent="flex-end" flexDirection="row">
        <IconButton onClick={handleCloseUpgradePlan}>
          <Close />
        </IconButton>
      </Stack>
      <UpgradePlanPageComponent contactUsHandler={handleContactUs} />
      <ContactOptionsModal
        isOpen={isContactOptionsModalOpen}
        setIsOpen={setIsContactOptionsModalOpen}
        openConfirmCancelModal={openConfirmCancelModal}
        onCustomPlanRequest={() => setIsUpgradeLeadModalOpen(true)}
        plansWithout5ReportBlocker={constants.data.plansWithout5ReportBlocker}
        validReportCountThreshold={constants.data.validReportCountThreshold}
        blockUpgradeWindowThreshold={constants.data.blockUpgradeWindowThreshold}
      />
      <SalesLeadModal
        open={isUpgradeLeadModalOpen}
        onClose={() => setIsUpgradeLeadModalOpen(false)}
        variant="upgrade"
      />
      <ConfirmCancelModal
        isOpen={isConfirmCancelModalOpen}
        onClose={() => setIsConfirmCancelModalOpen(false)}
        onCancel={() => {
          setIsConfirmCancelModalOpen(false);
          setIsCancellationReasonsModalOpen(true);
        }}
        openSuccessModal={openSuccessModal}
        showDownsell={true}
        showCheaperPlanLink={showCheaperPlanLink}
      />

      <CancellationReasonsModal
        isOpen={isCancellationReasonsModalOpen}
        onClose={(reason) => {
          handleCancellationModalClose(reason);
        }}
      />
      {isUserExperienceSurveyModalOpen && (
        <CancelUserExperienceModal
          onClose={(rating) => handleCloseUserExperienceSurveyModal(rating)}
        />
      )}
      <TrustPilotModal
        isOpen={isTrustPilotModalOpen}
        onClose={() => setIsTrustPilotModalOpen(false)}
      />
    </ChatPageContainerStack>
  );
};
